import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const LoaderWrapper = styled(Box).attrs(({ theme }) => ({
  width: 120,
  height: 120,
  margin: '90px auto 0',
  padding: '20px',
  justify: 'center',
  align: 'center',
  border: `1px solid ${theme.colors.lightLineDivider}`,
  borderRadius: 4,
}))``;

export const NoResultsWrapper = styled(Box).attrs({
  align: 'center',
  marginTop: '90px',
})`
  @media (max-width: ${BP_LAPTOP}px) {
    min-height: 250px;
  }
`;

export const ScrollableList = styled(Box).attrs({
  position: 'relative',
})`
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.lightLineDivider} transparent;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
    border-radius: 8px;
  }
  @media (max-width: ${BP_LAPTOP}px) {
    overflow: auto;
    max-height: 250px;
  }
`;
